export const FETCH_TPPS_REQUEST = 'TPPS/FETCH_TPPS_REQUEST';
export const FETCH_TPPS_SUCCESS = 'TPPS/FETCH_TPPS_SUCCESS';
export const FETCH_TPPS_FAILURE = 'TPPS/FETCH_TPPS_FAILURE';

export const EDIT_TPP_REQUEST = 'BLOCKADES/EDIT_TPP_REQUEST';
export const EDIT_TPP_SUCCESS = 'BLOCKADES/EDIT_TPP_SUCCESS';
export const EDIT_TPP_FAILURE = 'BLOCKADES/EDIT_TPP_FAILURE';
